import { FEATURE_IDS, type FeatureId } from "@/config/feature-ids";
import type { FeatureFlag, FeatureManagementPayload } from "./types";

export const parseFeatureFlags = (raw: string | undefined): FeatureFlag[] => {
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw) as FeatureManagementPayload;
    return parsed.feature_management?.feature_flags ?? [];
  } catch (exception) {
    console.warn("[FeatureFlags] Invalid feature management JSON – all flags disabled.", exception);
    return [];
  }
};

export const buildFeatures = (flags: FeatureFlag[]) => {
  const isEnabled = (id: FeatureId): boolean => flags.find((f) => f.id === id)?.enabled ?? false;

  return {
    kretaLogin: isEnabled(FEATURE_IDS.KretaLogin),
    register: isEnabled(FEATURE_IDS.Register),
  };
};
